import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import useCurrentCourse from '@src/hooks/useCurrentCourse';
import useForum from '@src/hooks/useForum';
import { STATE_SUCCESS } from '@src/const/common';
import { getIsSignIn } from '@src/store/selectors';

import { ReplyIcon } from 'src/components/common/icon';
import InputMessage from '../inputMessage';

const ReplyButton = styled.div`
	display: inline-flex;
	cursor: pointer;
`;

const ButtonText = styled.span`
	transform: translateY(2px);
`;

const OperatorWrapper = styled.div`
	border-top: 1px solid #E9E9E9;
	padding-top: 20px;
	margin-top: 20px;
`;

interface IReplyMessageOperator {
	commentId: string;
}

const ReplyMessageOperator = ({
	commentId,
}: IReplyMessageOperator): JSX.Element => {
	const isSignedIn = useSelector(getIsSignIn) as boolean;
	const { t } = useTranslation();
	const [toggleInputBox, setToggleInputBox] = useState(false);
	const { currentCourse: { id } } = useCurrentCourse();
	const {
		handleAddCourseMessageReply,
		addCourseDiscussionReplyStates,
	} = useForum({ courseId: id });
	const addCourseDiscussionReplyState = addCourseDiscussionReplyStates[commentId];

	const handleCloseInput = () => {
		setToggleInputBox(false);
	};

	useEffect(() => {
		if (addCourseDiscussionReplyState === STATE_SUCCESS) {
			handleCloseInput();
		}
	}, [addCourseDiscussionReplyState]);

	return isSignedIn && (
		<OperatorWrapper>
			{
				toggleInputBox ? (
					<InputMessage
						isReplier
						rows={3}
						handleMessageSubmit={message => handleAddCourseMessageReply('forum', { commentId, message })}
						addMessageState={addCourseDiscussionReplyState}
						buttonPosition="bottom"
						handleOnCancel={handleCloseInput}
					/>
				) : (
					<ReplyButton onClick={() => setToggleInputBox(true)}>
						<ReplyIcon />
						<ButtonText>{t('course:discussions:reply')}</ButtonText>
					</ReplyButton>
				)
			}
		</OperatorWrapper>
	);
};

export default ReplyMessageOperator;
